<div class="addArticleToOffer" *ngIf="form && filtersForm">
  <div class="addArticleToOffer-search">
    <div class="addArticleToOffer-searchFilter">
      <h2 class="h5">{{ 'MODALS.ADD_ARTICLE_TO_OFFER.FILTER' | translate }}</h2>

      <div>
        <h2 class="h6">{{ 'MODALS.ADD_ARTICLE_TO_OFFER.CATEGORY' | translate }}</h2>
        <div class="addArticleToOffer-searchFilterCategories">
          <app-checkbox *ngFor="let category of dropdownData.categories  || []" [options]="[category]"
            [mainForm]="categoriesForm" [controlName]="category.displayName" [labelKey]="'displayName'"
            [layoutMod]="['box', 'small']">
          </app-checkbox>
        </div>
      </div>

      <div>
        <h2 class="h6">{{ 'MODALS.ADD_ARTICLE_TO_OFFER.LIST_PRICE' | translate }}</h2>
        <div class="addArticleToOffer-searchFilterPrice" >
          <div>
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="filtersForm" [controlName]="'listPriceMin'">
            </app-input>
          </div>
          <div>
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="filtersForm" [controlName]="'listPriceMax'">
            </app-input>
          </div>
        </div>
      </div>

      <div *ngIf="isDealer">
        <h2 class="h6">{{ 'MODALS.ADD_ARTICLE_TO_OFFER.PURCHASE_PRICE' | translate }}</h2>
        <div class="addArticleToOffer-searchFilterPrice">
          <div>
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="filtersForm"
              [controlName]="'purchasePriceMin'">
            </app-input>
          </div>
          <div>
            <app-input [type]="'number'" [suffix]="'currency'" [mainForm]="filtersForm"
              [controlName]="'purchasePriceMax'">
            </app-input>
          </div>
        </div>
      </div>

    </div>

    <div class="addArticleToOffer-searchResults">
      <div class="addArticleToOffer-searchResultsContainer">
        <app-table-form [resourceType]="resourceType" [additionalFilters]="filters"
          (rowSelected)="onItemSelected($event)">
        </app-table-form>
      </div>
    </div>
  </div>

  <div class="addArticleToOffer-position">
    <form [formGroup]="form" class="form">
      <div class="form-body">
        <div class="form-section" >
          <app-form-row
            [label]="['FORMS.POSITION.NUMBER', 'FORMS.POSITION.DESCRIPTION'] | translateControl : form | async">
            <div class="row">
              <div class="col-md-4" >
                <app-input [type]="'number'" [mainForm]="form" [controlName]="'number'">
                </app-input>
              </div>
              <div class="col-md-8" *ngIf="form.controls.text">
                <app-input
                  [type]="'text'"
                  [mainForm]="form"
                  [controlName]="'description'"
                  [charCounter]="true"
                  [maxChars]="maxDescriptionLength"
                ></app-input>
              </div>
            </div>
          </app-form-row>

          <div class="collapseArea">
            <div class="collapseArea-trigger" aria-controls="collapseBasic" (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed" [ngClass]="{'collapseArea-trigger_open': !isCollapsed}">
              <i svgIcon [icon]="'arrow'" [ngClass]="{'_open': !isCollapsed}"></i>
              {{'FORMS.POSITION.TEXT' | translate}}
              <app-tooltip
                [hasTooltip]="true"
                [insideModal]="true"
                [text]="'GENERAL.NO_POSITION_TEXT_XML' | translate">
                <span
                  svgIcon
                  [icon]="'info'"
                  [iconSize]="svgIconSizeMod.DEFAULT"
                  class="iconInfo"
                ></span>
              </app-tooltip>
            </div>
            <div [collapse]="isCollapsed" [isAnimated]="true">
              <div class="collapseArea-body" *ngIf="form.controls.positionTemplate">
                <app-dropdown [mainForm]="form" [controlName]="'positionTemplate'"
                  [options]="dropdownData.positionTemplates" [labelKey]="'name'" [valueKey]="'text'">
                </app-dropdown>

                <app-textarea [mainForm]="form" [controlName]="'text'">
                </app-textarea>
              </div>
            </div>
          </div>

          <div class="addArticleToOffer-positionQuantity"
            [ngClass]="{'addArticleToOffer-positionQuantity_open': !isCollapsed}">
            <div class="addArticleToOffer-positionQuantityInner">
              <app-form-row [label]="['FORMS.POSITION.QUANTITY'] | translateControl : form | async">
                <app-input [type]="'number'" [mainForm]="form" [controlName]="'quantity'">
                </app-input>
              </app-form-row>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
